import { api } from '../services/api';

/** Download the model request captured for a chat's Nth assistant message as JSON. */
export const downloadAssistantContext = async (
  chatId: string,
  assistantIndex: number,
  lessonId?: string,
) => {
  const data = await api.getAssistantContext(chatId, assistantIndex);
  const filename = `context-${lessonId || 'lesson'}-${chatId}-a${assistantIndex}.json`;
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
